
const pulldownDefaultConfig = {
content: '下拉刷新',
height: 40,
autoRefresh: false,
downContent: '下拉刷新',
upContent: '释放后刷新',
loadingContent: '正在刷新...',
clsPrefix: 'xs-plugin-pulldown-',
}
const pullupDefaultConfig = {
content: '上拉加载更多',
pullUpHeight: 60,
height: 40,
autoRefresh: false,
downContent: '释放后加载',
upContent: '上拉加载更多',
loadingContent: '加载中...',
clsPrefix: 'xs-plugin-pullup-',
}

import CheckIcon from 'vux/src/components/check-icon/index.vue'
import Group from 'vux/src/components/group/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import Checklist from 'vux/src/components/checklist/index.vue'


import cfr from './cfrList'
export default {
name: 'batch_table',
components: {
CheckIcon,
cfr,
PopupRadio,
Checklist,
},
data() {
return {
tableId: 0,
tableName: '',
isBaby: false,
subtitle1: '',
subtitle2: '',
list_id: '',
shifts: '',
total: 0,
normal: 0,
warn: 0,
warnUser: [],
list_id: '',
showCfrList: false,
cfrText: '',
postFun: {},
form: {
room: '',
hand_card: '',
baby_id: '',
momName: '',
sex: '',
momName: '',
birth_type: '',
record_date: this.currentDate(),
record_hour: '',
detail: '',
agent_id: '',
agent_sign: '',
shifts: '',
},
baby_list: [],
showSignature: true,
option: {
penColor: 'rgb(0, 0, 0)',
},
get_host: host.host,
showDialog: false,
buttonTabVal: 0,
results: [],
keyword: '',
panel_type: '1',
memberList: [],
memberAllList: [],
floor_arr: [],
sort: '2',
sort_text: '倒序',
page: '1',
pullupDefaultConfig: pullupDefaultConfig,
pulldownDefaultConfig: pulldownDefaultConfig,
}
},
methods: {

go_leave_custom() {
this.$router.push({
path: './leave_custom_list',
})
},

toBatch() {
this.$router.push({
path: './batch_service',
})
},
change() {
this.normal = 0
this.memberList.forEach((item) => {
if (item.isSelect) {
item.state = 1
this.normal++
} else {
item.state = 2
}
})
this.warn = this.total - this.normal





















this.memberList.sort((a, b) => {
return a.state - b.state
})

console.log('change', this.memberList)
},
dialog_exit() {
this.showDialog = false
},

selectPeople() {
this.showCfrList = true
},

cfrListEven(val, item) {
this.showCfrList = val
if (item) {
this.form.agent_id = item.id
console.log('this.form.agent_id', this.form.agent_id)
this.cfrText = item.user_name

if (this.tableId > 2) {

this.memberList.forEach((member) => {
var staff_ids = member.staff_ids
var isSelected = false
staff_ids.forEach((id) => {
if (parseInt(id) == parseInt(item.id)) {
isSelected = true
}
})
if (isSelected) {
member.state = 1
member.isSelect = true
} else {
member.state = 2
member.isSelect = false
}
})

this.change()
}




}
},
currentDate() {
let date = new Date()
let year = date.getFullYear() 
let month = date.getMonth() + 1 
let day = date.getDate() 
return `${year}-${month}-${day}`
},
submit() {
this.showDialog = true
},
dialog_confirm() {
if (this.form.agent_sign == '') {
this.$vux.toast.show({
type: 'cancel',
text: '请提交签名',
})
return
}
if (this.form.shifts == '') {
this.$vux.toast.show({
type: 'cancel',
text: '请选择班次',
})
return
}
if (this.form.agent_id == '') {
this.$vux.toast.show({
type: 'cancel',
text: '请选择查房人',
})
return
}

this.$vux.loading.show({
text: '正在提交',
})
let that = this

var postData = {
store_id: this.$cookie.get('store_id'),
advisory_agent_sign: this.form.agent_sign,
advisory_agent_id: this.form.agent_id,
token: this.$cookie.get('token'),
shifts: this.form.shifts,
advisory_date: this.form.record_date,
}

if (this.isBaby) {
postData.child = this.memberList
} else {
postData.maternal_info = this.memberList
}

console.log(this.memberList)

this.postFun(postData, this.tableId).then((res) => {
if (res.errcode == 1) {
var id = res.data.id
this.$vux.loading.hide()
this.showDialog = false
this.$router.push({
path: './batch_success?id=' + id,
})
} else {
this.$vux.loading.hide()
this.$vux.toast.show({
type: 'cancel',
text: res.errinfo,
})
}
})
},


sortSearchBtn() {












},

tabChange(index) {
let that = this
this.buttonTabVal = index
this.keyword = ''
if (index == 1) {
this.sort = '1'
}
this.refresh()
},
panelClick(item) {},

formatDateTime(inputTime) {
var date = new Date(parseInt(inputTime) * 1000)
var y = date.getFullYear()
var m = date.getMonth() + 1
m = m < 10 ? '0' + m : m
var d = date.getDate()
d = d < 10 ? '0' + d : d
var h = date.getHours()
h = h < 10 ? '0' + h : h
var minute = date.getMinutes()
var second = date.getSeconds()
minute = minute < 10 ? '0' + minute : minute
second = second < 10 ? '0' + second : second
return y + '-' + m + '-' + d
},
searchReset() {
this.keyword = ''
this.searchBtn()
},

searchBtn() {






this.memberList = []

this.memberAllList.forEach((item) => {
var hasKey = false

if (this.keyword != '') {
hasKey =
item.phone.indexOf(this.keyword) != -1 ||
item.room.indexOf(this.keyword) != -1 ||
item.name.indexOf(this.keyword) != -1
console.log('hasKey', hasKey, item.state)
if (hasKey) {
this.memberList.push(item)
}
} else {





this.memberList.push(item)
}
this.memberList.sort((a, b) => {
return a.state - b.state
})
})
},

clearSearch() {
this.keyword = ''

},
isInArray(arr, value) {
for (let item of arr) {
if (value === item) {
return true
}
}
return false
},
save() {
let signature = 'signature1'
console.info(this.$refs[signature])
let png = this.$refs[signature].save()
this.form.agent_sign = encodeURI(png)
this.showSignature = true
},
edit() {
this.showSignature = false
this.form.agent_sign = ''
},
clear() {
let signature = 'signature1'
let refs = this.$refs[signature].clear()
this.form.agent_sign = ''
},

apiBatchMemberList(str) {
this.$vux.loading.show({
text: '正在加载',
})
let that = this
let params = {
token: this.$cookie.get('token'),
type: '4',
keyword: this.keyword,
store_id: this.$cookie.get('store_id'),
page: this.page,
}
Api.memberListApi.getBatchList(params, this.tableId).then((res) => {
this.memberList = []
this.memberAllList = []
if (res.errcode == 1) {

this.total = res.data.length
this.normal = res.data.length
if (res.data.length) {
for (let item of res.data) {
if (this.tableId == 1 || this.tableId == 2) {
item.state = 1
item.isSelect = true
} else {
item.state = 2
item.isSelect = false
}

let _desc =
'电话：' +
item.phone +
' 时间：' +
this.formatDateTime(item.live_time) +
' 套餐：' +
item.package_name +
' 房号：' +
item.room

item.key = item.id
item.value = item.name
item.inlineDesc = _desc
item.temperature = ''
item.weight = ''
console.log('staff_id', item.staff_id)

this.memberList.push(item)
this.memberAllList.push(item)
}
}
this.$vux.loading.hide()
} else {
this.$vux.loading.hide()
this.$vux.toast.show({
type: 'cancel',
text: res.errinfo,
})
}
})
},

refresh() {
this.memberList = []
this.memberAllList = []
this.page = '1'
this.floor_arr = []
this.apiBatchMemberList('refresh')
},

loadMore() {
this.apiBatchMemberList()
},
goBack() {
this.$router.push({
path: './batch_service',
})
},
onConfirm() {
this.$router.push({
path: '/',
})
this.$cookie.set('token', '')
this.$cookie.set('id', '')
},

hengshuping() {
if (window.orientation == 180 || window.orientation == 0) {
alert('请使用横屏才能达到最佳浏览效果')
}
},

initData() {
this.tableId = parseInt(this.$route.query.tableId)

if (
this.tableId == 3 ||
this.tableId == 4 ||
this.tableId == 1 ||
this.tableId == 7
) {
this.isBaby = true
}

if (this.isBaby) {
this.subtitle1 =
'1.勾选客户为<span style="color:red">正常</span>客户宝宝，会自动进行批量处理；（注意多胎情况）'
this.subtitle2 =
'2.非勾选客户为<span style="color:red">异常</span>客户宝宝，需单独填写记录；'
}

if (this.tableId == 2 || this.tableId == 5 || this.tableId == 6) {
this.subtitle1 =
'1.勾选客户为<span style="color:red">正常</span>客户，需单独填写记录；'
this.subtitle2 =
'2.非勾选客户为<span style="color:red">异常</span>客户，会自动进行批量处理'
}
switch (this.tableId) {
case 3:
this.postFun = Api.memberListApi.batchAddBabyNursOne
this.tableName = '《婴儿护理记录单（1）》'
break
case 4:
this.postFun = Api.memberListApi.batchAddBabyNursTwo
this.tableName = '《婴儿护理记录单（2）》'
break
case 5:
this.postFun = Api.memberListApi.batchAddMaternalEverydayPhysiology
this.tableName = '《产妇每日生理护理记录表》'
break
case 6:
this.postFun = Api.memberListApi.batchAddMaterRehNursEvalData
this.tableName = '《产妇康复护理评估记录单》'
break
case 2:
this.postFun = Api.memberListApi.batchMatarnalHeathRecord
this.tableName = '《产妇健康咨询记录表》'
break
case 1:
this.postFun = Api.memberListApi.batchBabyHeathRecord
this.tableName = '《新生儿健康咨询记录表》'
break
case 7:
this.postFun = Api.memberListApi.batchAddBabyCareOpera
this.tableName = '《婴儿护理操作记录表》'
break
}

console.log('this.tableName', this.tableName)
console.log('this.subtitle1', this.subtitle1)
},
},




created() {




this.initData()
this.apiBatchMemberList()


















},
}



// WEBPACK FOOTER //
// ./src/components/batch_table.vue